
export const setupFAQ = () => { 

    const setupToggle = () => {
        var $current 
        var $this 
        $(document).on('click', '.faq-item__question', (e) => {
             $current = $(e.currentTarget).closest('.faq-item').find('.faq-item__answer').slideToggle(100)
             $this = $(e.currentTarget);
            slideUpAnswer()
            if($this.closest('.faq-item').hasClass('is-active')) {
                $this.closest('.faq-item').removeClass('is-active');
            } else {
                $this.closest('.faq-item').toggleClass('is-active');
            }
        })

        const slideUpAnswer = () => {
            $('.faq-item__answer').not($current).slideUp();
            $('.faq-item__answer').not($current).closest('.faq-item.is-active').removeClass('is-active');
        }
    }

      setupToggle();

      const globalToggle = () => {
          var $current 
          var $this 
          $(document).on('click', '.js-drop-down-action', (e) => {
               $current = $(e.currentTarget).closest('.js-drop-down-item').find('.js-drop-down-content').slideToggle(100)
               $this = $(e.currentTarget);
              slideUpAnswer()
              if($this.closest('.js-drop-down-item').hasClass('is-active')) {
                  $this.closest('.js-drop-down-item').removeClass('is-active');
              } else {
                  $this.closest('.js-drop-down-item').toggleClass('is-active');
              }
          })
  
          const slideUpAnswer = () => {
              $('.js-drop-down-content').not($current).slideUp(500, function() {
                  $('.js-drop-down-content').not($current).closest('.js-drop-down-item.is-active').removeClass('is-active');
              });
              
          }
      }
  
        globalToggle();

}

setupFAQ();